import { createSlice } from '@reduxjs/toolkit'
import { deleteApiKey } from '../../../components/workspace/settings/api-keys/confirm-delete-popup/slice'

const initialState = {
  data: {
    apiKeyUuid: '',
    name: '',
  },
  openForm: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'deleteApiKey',
  initialState,
  extraReducers(builder) {
    builder.addCase(deleteApiKey.fulfilled, () => initialState)
  },
  reducers: {
    openForm: (state, action) => {
      state.openForm = true
      state.data.uuid = action.payload.uuid
      state.data.name = action.payload.name
    },
    closeForm: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.deleteApiKey
export const selectFormData = (state) => selectSlice(state).data
export const selectError = (state) => selectSlice(state).error
export const isFormOpened = (state) => selectSlice(state).openForm
export const selectRequestStatus = (state) => selectSlice(state).status

const { reducer, actions } = slice

export const { changeRequestStatus, openForm, closeForm } = actions

export default reducer
